// Персональные данные
import {setStep2BusinessContainerHtml, setStep2BusinessContainerHtmlNew} from "@js/front/dwstroy.form_e-visa_iran/view";

export function stepPersonalInformation (proxy)
{
    const data = proxy.data;

    let controller = {
        checked: false,
        input: false,
    }
    const step = 'step'+data.step;

    // Получаем объект с LocalStorage
    const dataLocalStorage = data.getStepLocalStorage(proxy.locStorStepId, data.step);
    if (dataLocalStorage) data.setDataFormAddLocalStorage(data.dataForm[step], dataLocalStorage);

    const dataLS1 = data.getStepLocalStorage(proxy.locStorStepId, 1);

    // Если включена "Бизнес виза" добавляем новые поля
    if (dataLS1.id === '3') {
        data.setStep2BusinessContainerHtml(proxy, dataLocalStorage)
    } else {
        data.dataForm[step]['businessVisa'] = false
    }


    // Перезаписываем данные в Страховке(step7) если ранее она была заполнена
    const dataLocalStorage7 = data.getStepLocalStorage(proxy.locStorStepId, 7);

    if (dataLocalStorage7) {
        const priseNumber = proxy.data.insuranceCost(proxy, dataLocalStorage.age, dataLocalStorage7.validityInsurance.days)
        dataLocalStorage7.validityInsurance.price = proxy.data.numberWithSpaces(priseNumber) + BX.message('R')

        if (dataLocalStorage7) data.setDataFormAddLocalStorage(data.dataForm['step7'], dataLocalStorage7);
        proxy.data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, proxy.data.dataForm['step7'], 7);
    }

    // Заполняем в input данными с dataForm и обновляем dataForm
    data.setTextInputDataForm(proxy.fvcContainerId, data.dataForm[step]);

    // Записываем в radio данные
    data.setTextRadioDataForm(proxy, step);

    // Проверяем input на _error
    data.errorInputController(proxy, controller);

    errorRadiosController(proxy, controller);

    // Перезаписываем LocalStorage при вводе данных в input
    data.setInputClickLocalStorage(proxy, data.dataForm[step]);

    // Перезаписываем LocalStorage при выборе с Radio
    data.setRadioClickLocalStorage(proxy);

    const inputPhone = proxy.fvcContainerId.querySelector('[data-name=phone]')
    const companyPhone = proxy.fvcContainerId.querySelector('[data-name=companyPhone]')
    BX.bind(inputPhone, 'click', BX.proxy(inputClickPhone, proxy));
    BX.bind(companyPhone, 'click', BX.proxy(inputClickPhone, proxy));

    // Контроль радио кнопки и добавление активного класса
    proxy.fn.setBorderControlRadioLoad(proxy.fvcContainerId)

    // Очищаем от ошибок при клике на input
    const inputRequired = proxy.fvcContainerId.querySelectorAll('input[required]')
    inputRequired.forEach(input => {
        input.onclick = function (e) {
            proxy.data.deleteSuccessErrorText(e.target.closest('.input_container'))
        }
    })

    if (controller.input && controller.checked) {
        data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, data.dataForm[step], data.step);
        proxy.bNext.classList.add('in');
    }
}

// Проверяем radio на _error
function errorRadiosController (proxy, controller)
{
    const radios = proxy.fvcContainerId.querySelectorAll('.radio_control_js');
    let result = false;

    radios.forEach(radio => {
        const error = radio.closest('.radio_wrapper_too._error');
        const success = radio.closest('.radio_wrapper_too._success');

        if (error) {
            result = false;
        } else result = !(!error && !success);
    })

    controller.checked = result;
}

// Клик по полю с телефоном
function inputClickPhone(e) {
    let input;
    if ($(this).context) {
        input = $(this).context;
    } else {
        input = e.target;
    }

    let inputTel = input;

    // if (!input.value) input.value = '+';

    input.oninput = function () {
        // запрещаем изменять +
        // if (!input.value.startsWith('+')) input.value = '+';

        const reg = /[=!$%,<>#^*()/@&._A-Za-zA-Яа-яЁё-]/g; // только цифры и +
        input.value = input.value.substring(0, 15); // ограничение на 10 символа

        if (input.value.match(reg)) {
            input.value = input.value.replace(reg, '');
        }
    }

    // при потере фокуса проверяем что заполнено телефон помимо +7
    // input.onblur = checkPhoneNumber;


    /*
    function checkPhoneNumber() {
        // проверка есть ли такой класс _error
        const checkClass = input.parentElement.classList.contains('_error');
        const checkClass2 = input.parentElement.querySelector('._error_text')

        if (inputTel.value === '+7' && (!checkClass || !checkClass2)) {
            addElementClassError();
        } else if (checkClass || checkClass2) {
            deleteElementError();
        }
    }

    // Добавление текст ошибки и родителю класс _error а _success удаляем
    const addElementClassError = () => {
        const error = '<div class="_error_text">Не заполнен телефон</div>';
        input.parentElement.classList.remove('_success');
        input.parentElement.classList.add('_error');
        input.insertAdjacentHTML("afterend", error);
    }

    // Удаляем блок с ошибкой и класс _error а _success добавляем
    const deleteElementError = () => {
        input.onkeyup = function () {
            input.parentElement.classList.remove('_error');
            input.parentElement.classList.add('_success');
            // input.nextElementSibling.remove()
        };
    }
    */

}